import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { makeEntityScaffold } from '@classpass/saga-tools';
import SCHEDULE_CONTEXT from 'constants/schedule-context';
export var userProfile = makeEntityScaffold('SAGA.API.USER_PROFILE', function (client) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$forceReadFromMas = _ref.forceReadFromMaster,
      forceReadFromMaster = _ref$forceReadFromMas === void 0 ? false : _ref$forceReadFromMas;

  if (client.isUsingUnauthenticatedToken()) {
    if (__LOCAL_DEV__) {
      throw new Error('Refusing to make request for user profile endpoint with admin token.');
    } else {
      console.error('Returning null for request of user profile endpoint with admin token.'); // eslint-disable-line no-console

      return Promise.resolve(null);
    }
  }

  return client.users.activeUserProfile({
    fields: 'profile_image_url'
  }, {
    headers: forceReadFromMaster ? {
      'with-master': 1
    } : {}
  });
});
export var userPermissions = makeEntityScaffold('SAGA.API.USER_PERMISSIONS', function (client, userId) {
  return client.users.viewPermissions(userId);
});
export var userInactivePermissions = makeEntityScaffold('SAGA.API.USER_INACTIVE_PERMISSIONS', function (client, userId) {
  return client.users.inactivePermissions(userId);
});
export var userCancelMembership = makeEntityScaffold('SAGA.API.USER_UPDATE_MEMBERSHIP', function (client, userId, cancelReason, npsScore, cancelComment) {
  return client.users.updateMembership(userId, _objectSpread({
    action: 'cancel',
    cancellation_reason: cancelReason,
    nps_score: npsScore
  }, cancelComment && {
    comment: cancelComment
  }));
}); // Past classes over entire lifetime are not included in the userProfile

export var userPastReservationsCount = makeEntityScaffold('SAGA.API.USER_PAST_RESERVATIONS_COUNT', function (client, userId) {
  return client.users.viewFutureReservations(userId, {
    past: true,
    meta_only: true
  }).then(function (data) {
    return data.meta;
  });
});
export var userPastReservations = makeEntityScaffold('SAGA.API.USER_PAST_RESERVATIONS_RESERVATIONS', function (client, userId) {
  return client.users.viewReservationsV2(userId, {
    past: true
  }).then(function (data) {
    return data.reservations;
  });
});
export var userUpcomingReservations = makeEntityScaffold('SAGA.API.USER_UPCOMING_RESERVATIONS', function (client, userId) {
  return client.users.viewReservationsV2(userId).then(function (data) {
    return data.reservations;
  });
});
export var userVideoReservations = makeEntityScaffold('SAGA.API.USER_VIDEO_RESERVATIONS', function (client, userId) {
  return client.users.viewVideoReservations(userId);
});
export var studioBookmarks = makeEntityScaffold('SAGA.API.STUDIO_BOOKMARKS', function (client, userId) {
  return client.users.getBookmarks(userId).then(function (data) {
    return data.bookmarks;
  });
});
export var userCreditBalance = makeEntityScaffold('SAGA.API.USER_CREDIT_BALANCE', function (client, userId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isNextCycle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return client.lifecycle.getCreditBalance(userId, options, isNextCycle).then(function (data) {
    return data.data.credit_balance;
  });
}, {
  defaultKey: function defaultKey(client, userId, options, isNextCycle) {
    return isNextCycle ? SCHEDULE_CONTEXT.NEXT_CYCLE : SCHEDULE_CONTEXT.CURRENT_CYCLE;
  }
});
export var userCreditBalanceBreakdown = makeEntityScaffold('SAGA.API.USER_CREDIT_BALANCE_BREAKDOWN', function (client, userId) {
  return client.lifecycle.getCreditBalanceBreakdown(userId).then(function (data) {
    return data.data.sources.reduce(function (sources, source) {
      sources[source.credit_source] = _objectSpread({}, source);
      return sources;
    }, {});
  });
});
export var userSignUpEmail = makeEntityScaffold('SAGA.API.EMAIL_SIGNUP', function (client, userData, signUpData) {
  var firstName = userData.firstName,
      lastName = userData.lastName,
      email = userData.email,
      password = userData.password,
      newsletterSubscribed = userData.newsletterSubscribed;
  var conversion = signUpData.conversion,
      planId = signUpData.planId,
      promotionId = signUpData.promotionId,
      offerId = signUpData.offerId;
  return client.users.create(_objectSpread({
    user: {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password
    },
    newsletter_subscribed: newsletterSubscribed
  }, conversion && Object.keys(conversion).length && {
    conversion: conversion
  }, planId && {
    plan_id: planId
  }, promotionId && {
    promotion_id: promotionId
  }, offerId && {
    offer_id: offerId
  }));
});
export var userSignUpFacebook = makeEntityScaffold('SAGA.API.FACEBOOK_SIGNUP', function (client, token, signUpData) {
  var conversion = signUpData.conversion,
      planId = signUpData.planId,
      promotionId = signUpData.promotionId,
      offerId = signUpData.offerId;
  return client.users.create(_objectSpread({
    facebook: {
      token: token
    }
  }, conversion && Object.keys(conversion).length && {
    conversion: conversion
  }, planId && {
    plan_id: planId
  }, promotionId && {
    promotion_id: promotionId
  }, offerId && {
    offer_id: offerId
  }));
});
export var userAnnouncements = makeEntityScaffold('SAGA.API.USER_ANNOUNCEMENTS', function (client) {
  return client.users.announcements();
});
export var userAccountSummary = makeEntityScaffold('SAGA.API.USER_ACCOUNT_SUMMARY', function (client) {
  return client.users.accountSummary();
});